import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {
  ExamAddressesClient,
  ExamReportResponse, ExamReportsClient, ExamReportStatus,
  SelectListResponse,
} from '../../../generated-client/generated-api-client';
import {Observable} from 'rxjs';
import {dateTimeIsEarlierThanValidator} from '../../../custom-validators/dateTimeIsEarlierThanValidator';
import {
  isFormModifiedDataService,
  SimpleNavigationService
} from '../../../services/data-services/navigation-data-services';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {datesAreOnSameDayValidator} from 'src/app/custom-validators/datesAreOnSameDayValidator';
import {dateTimeIsLaterThanValidator} from '../../../custom-validators/dateTimeIsLaterThanValidator';
import {TenantService} from '../../../services/tenant.service';
import {DateTime, Duration} from 'luxon';
import {ActivatedRoute, Router} from '@angular/router';
import {dateTimeIsLaterThanOrEqualValidator} from "../../../custom-validators/dateTimeIsLaterThanOrEqualValidator";
import {dateTimeIsEarlierThanOrEqualValidator} from "../../../custom-validators/dateTimeIsEarlierThanOrEqualValidator";
import {ConfirmModalComponent} from "../../modals/confirm-modal/confirm-modal.component";
import {SimpleModalService} from "ngx-simple-modal";
import { DatetimepickerDirective } from 'src/app/directives/datetimepicker/datetimepicker.directive';

@Component({
  selector: 'app-exam-report-form',
  templateUrl: './exam-report-form.component.html',
  styleUrls: ['./exam-report-form.component.sass'],
})
export class ExamReportFormComponent implements OnInit {
  examAddressesSelectList!: SelectListResponse;
  isModifiable?: boolean;
  examReportStatus?: ExamReportStatus;
  @Input() response?: Observable<ExamReportResponse>;
  @Output() onSubmitCallback: EventEmitter<any> = new EventEmitter();

  form!: FormGroup;
  isLoading: boolean = true;
  examReportId: string = '';
  realExamStartedAtUtc?: DateTime;
  realExamEndedAtUtc?: DateTime;
  isSyncronised: boolean = false;

  // initialTenantId?: string;
  // formResponse?: ExamReportResponse;

  constructor(
    private examAddressClient: ExamAddressesClient,
    private examReportsClient: ExamReportsClient,
    private _isFormModifiedDataService: isFormModifiedDataService,
    private errorProcessorService: ErrorProcessorService,
    private _modalService: SimpleModalService,
    private _tenantService: TenantService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _navigationService: SimpleNavigationService
  ) {

  }

  ngOnInit(): void {
    if (!this.response) {
      this.isModifiable = true;
      this.examAddressClient.getExamAddresses(true).subscribe(
        response => {
          this.examAddressesSelectList = response;
          this.setForm();
        },
        error => this.errorProcessorService.processError(error, false, true)
      );
    }
    this.response?.subscribe(
      next => {
        this.examReportId = next.id ?? '';
        this.examReportsClient.isModifiable(this.examReportId).subscribe(next2 => {
          this.isModifiable = next2;
          this.examReportsClient.status(this.examReportId).subscribe(next3 => {
            this.examReportStatus = next3;
            this.examAddressClient.getExamAddresses(true).subscribe(
              next4 => {
                this.examAddressesSelectList = next4;
                this.realExamStartedAtUtc = next.realExamStartedAtUtc;
                this.realExamEndedAtUtc = next.realExamEndedAtUtc;
                this.examReportsClient.syncGet(this.examReportId).subscribe(
                  response => {
                    this.isSyncronised = response.isSyncronized??false;
                    this.setForm(next);
                  },
                  error => this.errorProcessorService.processError(error, false, true));
              },
              error => this.errorProcessorService.processError(error, false, true)
            );
          });

        });

      },
      error => this.errorProcessorService.processError(error, false, true)
    );
  }

  get id() {
    return this.form?.get('id');
  }
  get identifier() {
    return this.form?.get('identifier')!;
  }
  get isExamStartAutomatic() {
    return this.form?.get('isExamStartAutomatic')!;
  }
  get isSkipAllow(){
    return this.form?.get('isSkipAllow')!;
  }
  get registerDocuments(){
    return this.form?.get('registerDocuments')!;
  }
  get percentagePrecision(){
    return this.form?.get('percentagePrecision')!;
  }
  get examAddressId() {
    return this.form?.get('examAddressId')!;
  }
  get examStartedAtUtc() {
    return this.form?.get('examStartedAtUtc')!;
  }
  get examEndedAtUtc() {
    return this.form?.get('examEndedAtUtc')!;
  }
  get openedAtUtc() {
    return this.form?.get('openedAtUtc')!;
  }
  get closedAtUtc() {
    return this.form?.get('closedAtUtc')!;
  }

  onSubmit(): void {
    this.onSubmitCallback.emit([this.form]);
  }

  onGoBack(path: string){
    this._navigationService.navigateTo(path);
  }

  setForm(response?: ExamReportResponse) {
    this.form = new FormGroup({
      id: new FormControl(response?.id),
      identifier: new FormControl(response?.identifier, [Validators.required]),
      isExamStartAutomatic: new FormControl(response?.isExamStartAutomatic ?? true),
      isSkipAllow: new FormControl(response?.isSkipAllow ?? true),
      registerDocuments: new FormControl(response?.registerDocuments ?? false),
      percentagePrecision: new FormControl(response?.percentagePrecision ?? 0, [
        Validators.required,
      ]),
      examAddressId: new FormControl(response?.examAddressId, [Validators.required]),
      examStartedAtUtc: new FormControl(response?.examStartedAtUtc, [
        Validators.required,
      ]),
      examEndedAtUtc: new FormControl(response?.examEndedAtUtc, [
        Validators.required,
      ]),
      openedAtUtc: new FormControl(response?.openedAtUtc, [
        Validators.required,
      ]),
      closedAtUtc: new FormControl(response?.closedAtUtc, [
      ]),
    }, {validators: [this.openedClosedDateValidator, this.examStartEndDateValidator,
        this.startedOpenedDateValidator, this.endedClosedDateValidator]} );

    if (!this.isModifiable || (this.examReportStatus != ExamReportStatus.Open && this.isSyncronised)) {
      this.form.disable();
      // if (this.examReportStatus != 'Closed'){
      //   this.closedAtUtc.enable();
      // }
    }
    this.errorProcessorService.formGroup = this.form;
    this.isLoading = false;
    this.form.valueChanges.subscribe(() => {
      this._isFormModifiedDataService.isFormModified = true;
    });
  }

  openedClosedDateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    const fromStr = control.get('openedAtUtc')?.value;
    const toStr = control.get('closedAtUtc')?.value;

    if (!fromStr) return null;
    if (!toStr) return null;

    const fromDate = DateTime.fromISO(fromStr);
    const toDate = DateTime.fromISO(toStr);

    if (fromDate.day != toDate.day) return { openedClosedNotOnSameDay: true };

    return fromDate >= toDate ? { openedClosedInvalidDate: true } : null;
  };

  examStartEndDateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    const fromStr = control.get('examStartedAtUtc')?.value;
    const toStr = control.get('examEndedAtUtc')?.value;

    if (!fromStr) return null;
    if (!toStr) return null;

    const fromDate = DateTime.fromISO(fromStr);
    const toDate = DateTime.fromISO(toStr);

    if (fromDate.day != toDate.day) return { examStartEndNotOnSameDay: true };

    return fromDate >= toDate ? { examStartEndInvalidDate: true } : null;
  };

  startedOpenedDateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    const fromStr = control.get('openedAtUtc')?.value;
    const toStr = control.get('examStartedAtUtc')?.value;

    if (!fromStr) return null;
    if (!toStr) return null;

    const fromDate = DateTime.fromISO(fromStr);
    const toDate = DateTime.fromISO(toStr);

    return fromDate > toDate ? { startedOpenedInvalidDate: true } : null;
  };

  endedClosedDateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    const fromStr = control.get('examEndedAtUtc')?.value;
    const toStr = control.get('closedAtUtc')?.value;

    if (!fromStr) return null;
    if (!toStr) return null;

    const fromDate = DateTime.fromISO(fromStr);
    const toDate = DateTime.fromISO(toStr);

    return fromDate > toDate ? { endedClosedInvalidDate: true } : null;
  };
}
